import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-shinsegae-navy text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="mb-4">
            <h3 className="text-xl font-semibold mb-2">신세계 그룹</h3>
            <p className="text-gray-300">
              Cloudflare WARP VPN 설치 및 접속 안내
            </p>
          </div>

          <div className="border-t border-gray-600 pt-4">
            <p className="text-sm text-gray-400">
              © 2025 Shinsegae Group. All rights reserved.
            </p>
            <p className="text-xs text-gray-500 mt-2">
              본 페이지는 신세계 그룹 임직원의 원격근무 지원을 위해 제작되었습니다.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
